<template>
  <div>
    <el-button v-hasPermi="[`${permPrefix}:create`]" class="mb-12px" type="primary" @click="emit('add')">
      <Icon icon="ep:plus" />新增
    </el-button>
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column
        v-for="col in columns"
        :key="col.prop"
        :label="col.label"
        :prop="col.prop"
        :width="col.width"
        :min-width="col.minWidth"
      />
      <el-table-column label="操作" width="160" fixed="right">
        <template #default="{ row }">
          <el-button v-hasPermi="[`${permPrefix}:update`]" link type="primary" @click="emit('edit', row)">
            编辑
          </el-button>
          <el-button v-hasPermi="[`${permPrefix}:delete`]" link type="danger" @click="emit('delete', row.id)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  loading: boolean
  list: any[]
  columns: Array<{ prop: string; label: string; width?: number; minWidth?: number }>
  permPrefix: string
}>()
const emit = defineEmits<{ add: []; edit: [row: any]; delete: [id: number] }>()
</script>
